module.exports = __webpack_public_path__ + "img/img-mp-logo.09afc4af.png";